import { render, staticRenderFns } from "./procTodos.vue?vue&type=template&id=0cb1ce90&"
import script from "./procTodos.vue?vue&type=script&lang=js&"
export * from "./procTodos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports